import * as React from 'react';
import IOrderPricing from './IOrderPricing';
import Big, { BigConstructor } from 'big.js';
import { noLeadingZeros } from '@market/features/helpers/functions';
import { CurrencyUpper } from '@market/features/const.market';
import { numberWithDelimiter } from '@features/utils/functions';
import { max2Decimal, max4Decimal } from '../../../../regexps';


import * as style from './OrderPricingStyle.module.scss'
const maxBackendNumberRange = 99999999;

export default class OrderPricing extends React.PureComponent<IOrderPricing> {

  private big: BigConstructor = Big();

  onChangePrice = (e: React.ChangeEvent<any>) => {
    const value = e.target.value;
    const valueAsNumber = Number(value);

    if (value >= 0 && max2Decimal.test(value) && value <= maxBackendNumberRange) {
      this.props.updateState({
        orderedPricePerShare: value,
        totalValue: this.calculateTotalValue(valueAsNumber, this.props.numberOfSharesInput),
      });
    }
  }

  onChangeAmount = (e: React.ChangeEvent<any>) => {
    const value = e.target.value;
    const valueAsNumber = Number(value);

    if (valueAsNumber >= 0 && max4Decimal.test(value)) {
      // if sell order page
      if (this.props.availableNumberOfShares && this.big(valueAsNumber).lte(this.props.availableNumberOfShares)) {
        this.props.updateState({
          orderedNumberOfShares: value,
          convertShares: false,
          totalValue: this.calculateTotalValue(this.props.pricePerShareInput, valueAsNumber),
        });
      // if buy order page
      } else if (!this.props.availableNumberOfShares) {
        this.props.updateState({
          orderedNumberOfShares: value,
          totalValue: this.calculateTotalValue(this.props.pricePerShareInput, valueAsNumber),
        });
      }
    }
  }

  calculateTotalValue(price: number, numberOfShares: number) {
    return this.big(Number(numberOfShares)).times(Number(price)).toFixed(4);
  }

  setMaxShares = () => {
    if (this.props.availableNumberOfShares) {
      this.props.updateState({
        orderedNumberOfShares: this.props.availableNumberOfShares,
        totalValue: this.calculateTotalValue(this.props.pricePerShareInput, this.props.availableNumberOfShares),
      });
    }
  }

  renderHeader = () => {
    if (this.props.header) {
      return (
        <div className={style.top}>
          {this.props.header.map(elem => (
            <p key={elem.name}>
              {elem.name + ' '}
              {elem.value}
            </p>
          ))}
        </div>
      );
    }

    return null;
  }

  render() {
    const { numberOfSharesInput, availableNumberOfShares } = this.props;
    return (
      <div className={style.orderPricing}>
        {this.renderHeader()}
        <div className={style.bottom}>
          <div>
            <div className={style.box}>
              <p>Shares Amount</p>
              <input
                onChange={this.onChangeAmount}
                value={numberOfSharesInput || ''}
                placeholder="Enter Amount"
                step="any"
                data-cy="shares-amount"
              />
            </div>
            {availableNumberOfShares && numberOfSharesInput !== availableNumberOfShares && (
              <span
                className={style.sellAll}
                onClick={this.setMaxShares}
              >
                Sell all your shares ({numberWithDelimiter(noLeadingZeros(availableNumberOfShares))})
              </span>
            )}
          </div>
          <div className={style.box}>
            <p>Price per share ({CurrencyUpper})</p>
            <input
              onChange={this.onChangePrice}
              value={this.props.pricePerShareInput || ''}
              placeholder="Enter Price"
              step="any"
              data-cy="price-per-share"
            />
          </div>
          <div className={style.box}>
            <p>Value ({CurrencyUpper})</p>
            <input
              value={numberWithDelimiter(noLeadingZeros(this.props.totalOrderValue))}
              type="text"
              disabled={true}
              placeholder="Value"
            />
          </div>
        </div>
      </div>
    );
  }
}
